import React, { Component } from 'react';
import { connect } from 'react-redux';
import Orders from './orders';
import {take} from 'ramda';
import {lowestDenom} from '../../../../config';

class Buy extends Component {
  render() {
    let style = {}
    if(this.props.market.sellSide == false){
      style = {
        height:'705px',
        maxHeight:'705px'
      }
    }

    return (
      <div className="col s12 mainbook" id={'offertable'} style={style}>
        <Orders orderType={"buy"} orders={this.props.orders}/>
      </div>
    );
  }
}

function mapStateToProps(state,props) {
  let orders =  state.orderbook.sub_demand;
  let market = state.ui_marketplace.market;

  if(orders.length > 0){
    orders[0].cml = orders[0].price * orders[0].amount;
    for(let i = 1; i < orders.length;i++){
      orders[i].cml = orders[i-1].cml + orders[i].price*orders[i].amount
    }
  }
  let max = state.ui_marketplace.market.sellSide == false ? 35 : 17;

  for(let i = orders.length; i < max;i++) {
    orders.push({isBlank:true})
  }

  return {
    market: state.ui_marketplace.market,
    orders:take(max,orders)
  };
}

export default connect(mapStateToProps,{})(Buy);
